module.exports = __webpack_public_path__ + "img/chofu_zerosmoke_off.5ecce8f5.svg";